interface MetricDefinition {
  id: number;
  display_options: { code: string; type: string; label: string }[];
  extras?: {
    partially_sending_denominator?: boolean;
    partially_sending_numerator?: boolean;
  };
}

export const calculateReferralPercentage = (
  metricDefinitions: MetricDefinition[],
  metricsV2: Record<string, Record<string, number>>,
  volumeType: 'claims' | 'patients' = 'claims'
): number | null => {
  // Find the denominator and numerator metric definitions
  const denominatorMetric = metricDefinitions.find(
    (metric) => metric.extras?.partially_sending_denominator
  );
  const numeratorMetric = metricDefinitions.find(
    (metric) => metric.extras?.partially_sending_numerator
  );

  if (!denominatorMetric || !numeratorMetric) return null;

  // Get the metric codes for the selected volume type
  const denomCode = denominatorMetric.display_options.find(
    (option) => option.label.toLowerCase() === volumeType
  )?.code;
  const numerCode = numeratorMetric.display_options.find(
    (option) => option.label.toLowerCase() === volumeType
  )?.code;

  if (!denomCode || !numerCode) return null;

  // Get values from metrics_v2
  const denominator = metricsV2[denominatorMetric.id]?.[denomCode] ?? 0;
  const numerator = metricsV2[numeratorMetric.id]?.[numerCode] ?? 0;

  // Avoid division by zero
  if (denominator === 0) return null;

  // Calculate percentage: (1 - numerator/denominator) * 100
  return (1 - numerator / denominator) * 100;
};

export const getReferralCounts = (
  metricDefinitions: MetricDefinition[],
  metricsV2: Record<string, Record<string, number>>,
  volumeType: 'claims' | 'patients' = 'claims'
): { numerator: number; denominator: number } | null => {
  const denominatorMetric = metricDefinitions?.find(
    (metric) => metric.extras?.partially_sending_denominator
  );
  const numeratorMetric = metricDefinitions?.find(
    (metric) => metric.extras?.partially_sending_numerator
  );

  if (!denominatorMetric || !numeratorMetric) return null;

  const denomCode = denominatorMetric.display_options.find(
    (option) => option.label.toLowerCase() === volumeType
  )?.code;
  const numerCode = numeratorMetric.display_options.find(
    (option) => option.label.toLowerCase() === volumeType
  )?.code;

  if (!denomCode || !numerCode) return null;

  const denominator = metricsV2?.[denominatorMetric.id]?.[denomCode] ?? 0;
  const numerator = metricsV2?.[numeratorMetric.id]?.[numerCode] ?? 0;

  return { numerator, denominator };
};
